export default {
    image: {
        use: 'figure',
        imgClass: 'img',
        figureClass: 'fig-img',
        figCapClass: 'fig-cap',
        path: 'absolute',
    },
    paragraph: {
        pClass: 'paragraph',
    },
    code: {
        codeBlockClass: 'code-block',
    },
    embed: {
        useProvidedLength: false,
    },
    quote: {
        applyAlignment: false,
    },
};
//# sourceMappingURL=config.js.map